import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useLocation } from 'react-router';

const PrivateRoute: React.FC<{
  component: React.FC;
  path: string;
  exact: boolean;
}> = (props) => {
  const location = useLocation();
  const utmSource = new URLSearchParams(location.search).get('utm_source');
  const utmMedium = new URLSearchParams(location.search).get('utm_medium');
  const utmCampaign = new URLSearchParams(location.search).get('utm_campaign');

  const condition = localStorage.getItem('isLogin');
  if (location.pathname.endsWith('/login')) {
    if (condition) {
      return <Redirect to={`/`} />;
    } else {
      return (
        <Route
          path={props.path}
          exact={props.exact}
          component={props.component}
        />
      );
    }
    return null;
  }
  return condition ? (
    <Route path={props.path} exact={props.exact} component={props.component} />
  ) : (
    <Redirect to={`/login` + `?redirectUrl=${location.pathname}` + (utmCampaign != null ? '&utm_campaign=' + utmCampaign : '' ) + (utmMedium != null ? '&utm_medium=' + utmMedium : '') + (utmSource != null ? '&utm_source=' + utmSource : '')} />
  );
};
export default PrivateRoute;
